import React, { Component } from "react";
import { getAnswersWithSkip,getResponse } from "../../../../services/formService";
import Select from "react-select";
import _ from 'lodash';
class DropdownViewer extends Component {
 

  constructor(props){
    super(props);
    const{isMultiple} =this.props;
    this.state = {
      Question_ID: this.props.Question_ID,
      questionAnswers: [],
      Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
      Response_Required: this.props.Response_Required,
      loading: true,
      answerSelectedList:[],
      isMultiple,
      preloadQAData: this.props.preloadQAData ? this.props.preloadQAData : {},
    };
  }

  async componentDidMount() {
    //console.log('preloadQAData', this.state.preloadQAData)
    const{Question_ID} = this.state;
    const{PrimaryKey,Project_ID}=this.props;
    let { data: oldQuestionAnswers } = await getAnswersWithSkip(
      Question_ID
    );

    const { data: oldAnswerSelectedList } = await getResponse(
      PrimaryKey,
      Project_ID,
      Question_ID
    );

    const questionAnswers = _(oldQuestionAnswers)
    .map(obj=>{
      return {
        ...obj,
        Question_ID,
        label: obj.Answer_Text,
        value: obj.Answer_ID,
      };
    })
    .value();

    const answerSelectedList = _(questionAnswers).filter(obj=>{
      return _(oldAnswerSelectedList).find(ans=>ans.Answer_ID ===obj.Answer_ID)
    })
    .value();
    this.setState({ questionAnswers,answerSelectedList });
    this.state.preloadQAData.Answer_ID && this.setState({Answer_ID:this.state.preloadQAData.Answer_ID, Answer_Text: this.state.preloadQAData.Answer_Text})
    if (this.state.Answer_ID > 0) {
      this.handleSelection({ target: { value: this.state.Answer_ID } });
    }

    this.setState({ loading: false });
  }

  handleSelection = ({ target }) => {
    let Answer_ID = parseInt(target.value);
    let selected = this.state.questionAnswers.filter(
      (ans) => ans.Answer_ID === Answer_ID
    )[0];
    this.props.OnUpdate(this.props.Question_Number, {
      Responses:
        Answer_ID === "0"
          ? []
          : [
              {
                Question_Number:this.props.Question_Number,
                Question_ID: this.state.Question_ID,
                Answer_ID: Answer_ID,
                Answer_Text: selected.Answer_Text,
              },
            ],
      Skip: selected ? selected.SkipLogic : [],
      Response_Required: !this.state.loading && this.state.Response_Required,
    });
    this.setState({ Answer_ID });
  };

  handleMultiSelection = (answerSelectedList) =>{
    this.props.OnUpdate(this.props.Question_Number, {
      Question_Number:this.props.Question_Number,
      Responses:answerSelectedList,
      Skip: answerSelectedList && answerSelectedList.length > 0 ? answerSelectedList[0].SkipLogic : [],
      Response_Required: !this.state.loading && this.state.Response_Required,
    });
    this.setState({ answerSelectedList });
  }

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;

    const { answerSelectedList,Question_ID, questionAnswers, Answer_ID ,isMultiple} = this.state;
   
    return (
      <div className="form-group" key={"Q" + Question_ID}>
      
        {isMultiple===false &&<select
          className="form-control"
          onChange={this.handleSelection}
          value={Answer_ID}
        >
          <option key={"ans" + Question_ID + "default"} value="0">
            - Select -
          </option>
          {questionAnswers.map((ans) => (
            <option key={"mAns" + ans.Answer_ID} value={ans.Answer_ID}>
              {ans.Answer_Text}
            </option>
          ))}
        </select>}
        {
          isMultiple===true && <Select
          closeMenuOnSelect={false}
          isMulti
          value={answerSelectedList}
          options={questionAnswers}
          onChange={this.handleMultiSelection}
          classNamePrefix="select"
        />
        }
        
      </div>
    );
  }
}

export default DropdownViewer;
